<mat-drawer #preVisitFinishDrawer mode="over" style="position: fixed;height:100%; width:380px;border-radius:0 !important;z-index:10000;overflow:auto !important;" position="end" id="preVisitFinishDrawer" [(opened)]="vm.isOpen" *ngIf="vm.initialized">
	<div class="c-card" style="height:100%" *ngIf="vm.isOpen">
		<div class="c-content">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
					<button id="closeButton" type="button" class="c-button c-button--icon c-button--tp" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="c-content u-no-pt">
			<form class="c-form" #mainForm="ngForm" name="vm.form" (ngSubmit)="vm.submit(mainForm)" novalidate *ngIf="!vm.isSaving">
				<div class="c-form__group u-osb-lg">
					<label for="notes" class="c-form__label c-form__label--light">{{ 'Call.Content.Notes' | translate }}</label>
					<textarea name="notes" id="notes" #notes="ngModel" class="c-form__input c-form__input--sm" rows="8" [(ngModel)]="vm.otherDescriptionConf.content"></textarea>
				</div>
				<div class="c-form__group u-osb-lg" *ngIf="!vm.showEndInterviewSection">
					<button id="endInterviewNowButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.showEndInterviewSection = true">
						{{ 'PreVisit.Record_For_Person_Notes_Drawer.Want_To_End_Interview' | translate }}
					</button>
				</div>
				<div *ngIf="vm.showEndInterviewSection">
					<div class="c-form__group u-osb-lg" [ngClass]="{'c-form__group--error': vm.submitted && triageLevel.invalid }">
						<p>{{ 'PreVisit.Record_For_Person_Notes_Drawer.Set_Triage_level' | translate }}</p>
						<label class="c-radio  u-ost-md">
							<input type="radio" name="triageLevel" required [value]="'ROUTINE'" #triageLevel="ngModel"
										 [(ngModel)]="vm.triageLevel">
							<span id="routineTriageLevelLabel">{{'Symptom_Check.Results.Triage.Title.Consultation' | translate}}
								<i class="c-content--s1" style="float: right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
							</span>
						</label>
						<label class="c-radio ">
							<input type="radio" name="triageLevel" required [value]="'URGENT'" #triageLevel="ngModel"
										 [(ngModel)]="vm.triageLevel">
							<span id="urgentTriageLevelLabel">{{'Symptom_Check.Results.Triage.Title.Consultation_24' | translate}}
								<i class="c-content--s2" style="float: right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
							</span>
						</label>
						<label class="c-radio ">
							<input type="radio" name="triageLevel" required [value]="'ASAP'" #triageLevel="ngModel"
										 [(ngModel)]="vm.triageLevel">
							<span id="asapTriageLevelLabel">{{'Symptom_Check.Results.Triage.Title.Emergency' | translate}}
								<i class="c-content--s3" style="float: right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
							</span>
						</label>
						<label class="c-radio ">
							<input type="radio" name="triageLevel" required [value]="'STAT'" #triageLevel="ngModel"
										 [(ngModel)]="vm.triageLevel">
							<span id="statTriageLevelLabel">{{'Symptom_Check.Results.Triage.Title.Emergency_Ambulance' | translate}}
								<i class="c-content--s4 " style="float: right">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</i>
							</span>
						</label>
					</div>
					
					<div class="c-divider c-divider--h u-osb-lg"></div>
					
					<label for="wantSickLeave" class="c-form__label u-osb-xs ">{{'Symptom_Check.Results.Sick_Leave_Section' | translate}}</label>
					<div class="u-osb-lg" id="wantSickLeave" *ngFor="let additionalRequestOption of vm.additionalRequestOptions">
						<label class="c-checkbox">
							<input type="checkbox" name="additionalRequestOption.fieldName" [(ngModel)]="vm.selectedServiceIds[additionalRequestOption.id]">
							<span id="additionalRequestOptionLabel">{{ additionalRequestOption.label }}</span>
						</label>
					</div>
					
					<div class="c-divider c-divider--h u-osb-lg"></div>
					
					<div class="c-form__group u-ost-lg" >
						<p class="u-osb-md">{{ 'PreVisit.Record_For_Person_Notes_Drawer.Determine_Visit_Location' | translate }}</p>
						<div class="c-form__group u-osb-sm" id="locationSelection"
								 [ngClass]="{'c-form__group--error': vm.submitted && !vm.hasLocationSelected }"
								 *ngFor="let location of vm.locationSelection ; let $index=index">
							
							<label class="c-checkbox" [style]="location.customCss" *ngIf="vm.selectedServiceIds">
								<input type="checkbox" name="{{location.fieldName}}" [(ngModel)]="vm.selectedServiceIds[location.id]">
								<span id="locationLabel{{$index}}">{{ location.label }}</span>
							</label>
							<p class="c-text c-text--s3"
								 *ngIf="vm.submitted && !vm.hasLocationSelected && location.requiredErrorMessage">
								{{ location.requiredErrorMessage }}
							</p>
							<p *ngIf="location.type === 'TEXT_ERROR' && vm.submitted && vm.mainForm.invalid" class="c-text c-text--s3" [style]="location.customCss">
								{{ location.label }}
							</p>
						</div>
					</div>
					<button id="endInterviewSubmitButton" type="submit" class="c-button c-button--s1 c-button--fit">
						{{ 'PreVisit.Record_For_Person_Notes_Drawer.End_Interview' | translate }}
					</button>
				</div>
			</form>
			<loader-overlay *ngIf="vm.isSaving"></loader-overlay>
		</div>
	</div>
</mat-drawer>
